export default "__VITE_ASSET__6a3494fc__"